<template>
    <div>
        <div class="banner-container">
            <img class="career-img" src="../../assets/image/career/career-banner.jpg" />
            <p class="join-title">Join Our Team</p>
        </div>
        <el-breadcrumb class="breadcrumb-container" separator="/">
            <el-breadcrumb-item class="breadcrumb-item" :to="{ path: '/career' }">Career</el-breadcrumb-item>
            <el-breadcrumb-item class="breadcrumb-item">Finance Manager ( 财务经理 )</el-breadcrumb-item>
        </el-breadcrumb>
        <div class="job-container">
            <p class="title">Finance Manager ( 财务经理 )</p>
            <div class="description-container">
                <p class="subtitle"> 职位负责</p>
                <ul class="requirement-list">
                    <li class="list-details"> 负责会计核算和税务管理，保证核算真实准确、合规。</li>
                    <li class="list-details"> 负责财务全面预算工作。</li>
                    <li class="list-details"> 负责实物资产管理，保证帐实相符。</li>
                    <li class="list-details"> 负责统筹行内、外监管报表统计报送，财务经营分析，为行领导提供及时、准确、有效的内部财务分析报告。</li>
                    <li class="list-details"> 严格落实BAKONG和央行政策管理。</li>
                </ul>
                <p class="salary">SALARY: NEGOTIABLE</p>
                <p class="subtitle">岗位要求</p>
                <ul class="requirement-list">
                    <li class="list-details"> 专业和学历：财会、统计、金融等相关专业，大学本科或以上。</li>
                    <li class="list-details"> 工作经验：具有3年或以上银行财务工作经验。</li>
                    <li class="list-details"> 综合能力：熟练掌握企业会计核算及财经制度，熟悉财务分析软件、财会管理系统。责任心强，沟通能力佳，良好的语言表达能力和写作能力。</li>
                </ul>
            </div>

            <div class="description-container">
                <p class="subtitle">How to Apply</p>
                <p class="requirement-list">Interested candidates please submit your CV/resume with a photo and accompanied by cover letter and any other supporting documents to HR Department:</p>
                <div class="hr-contact">
                    <p class="hr-contact-details">Contact Person : HR Department</p>
                    <p class="hr-contact-details">Email: hr@u-pay.com</p>
                    <p class="hr-contact-details">Contact: 069 931 888 / 077 266 123 </p>
                    <p class="hr-contact-details">Website: www.u-pay.com</p>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
}
</script>

<style lang="less" scoped>
.banner-container {
  position: relative;
  .career-img {
    width: 100%;
  }
  .join-title {
    color: white;
    position: absolute;
    bottom: 3%;
    left: 4%;
    font-size: 2.2rem;
    font-weight: bolder;
  }
}
.job-container {
    display: table;
    margin-right: auto;
    margin-left: auto;
    padding: 3% 25% 3% 25%;
    .title {
        color: #0277E3;
        text-align: center;
        font-size: 1.55rem;
        font-weight: bold;
    }
}

.description-container{
    padding-top: 8%;
    .subtitle {
        color: black;
        text-align: center;
        font-size: 1.35rem;
        font-weight: bold;
    }
    .requirement-list{
        margin: 3% 0% 5% 0%;

        .list-details {
            margin-bottom: 0.5%;
            display: list-item;
            list-style-type: disc;
        }
    }
    .salary{
        font-weight: bolder;
    }

    .hr-contact .hr-contact-details {
        margin-bottom: 3%;
        font-weight: bold;
    }
}
.breadcrumb-container {
    margin : 3% 3%;
}

.breadcrumb-item {
    color: darkgray;
    font-weight: 600;
    font-size: 1.0rem;
}

@media only screen and (max-width: 600px) {
    .job-container {
        display: table;
        margin-right: auto;
        margin-left: auto;
        padding: 3% 5% 3% 5%;
        .title {
            color: #0277E3;
            text-align: center;
            font-size: 1.10rem;
            font-weight: bold;
        }
    }
}
</style>
